import React from "react";

const Agenda = () => (
  <section className="section-padding">
    <div style={{ textAlign: "center", marginBottom: "4rem" }}>
      <h3
        className="font-serif"
        style={{ fontSize: "2.5rem", color: "#1a2b56" }}
      >
        Agenda del encuentro
      </h3>
    </div>
    <div className="agenda-container">
      <div className="agenda-item">
        <div className="agenda-dot"></div>
        <span
          style={{ color: "#c4923e", fontWeight: "bold", fontSize: "0.8rem" }}
        >
          DÍA 1 - 16 de noviembre de 2026
        </span>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
         ✅ Eucaristía de apertura
        </p>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>✅ Acto inaugural</p>
        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
         ✅ Conferencia magistral
        </p>
        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>Buenas prácticas</p>
      </div>
      <div className="agenda-item">
        <div
          className="agenda-dot"
          style={{ backgroundColor: "#1a2b56" }}
        ></div>
        <span
          style={{ color: "#c4923e", fontWeight: "bold", fontSize: "0.8rem" }}
        >
         DÍA 2 - 17 de noviembre de 2026
        </span>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}> ✅ Eucaristía</p>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
         ✅ Conferencia: Identidad católica y carisma Idente en la gestión de las
          Comunicaciones
        </p>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
        ✅  Conversatorio: Agencias de Comunicación, Publicidad y Marketing que
          llevan cuentas de IES
        </p>
        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>✅ Buenas prácticas</p>
      </div>

      <div className="agenda-item">
        <div
          className="agenda-dot"
          style={{ backgroundColor: "#1a2b56" }}
        ></div>
        <span
          style={{ color: "#c4923e", fontWeight: "bold", fontSize: "0.8rem" }}
        >
          DÍA 3 – 18 de noviembre de 2026
        </span>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>✅ Eucaristía</p>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
          ✅ Conversatorio: Expectativas de las IES de los equipos de comunicación
        </p>

        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
        ✅  Conferencia: IA en la gestión de las comunicaciones universitarias
          católicas
        </p>
        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}> ✅Acto de clausura</p>
        <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
         ✅ Recorrido turístico (opcional){" "}
        </p>
      </div>
    </div>
  </section>
);

export default Agenda;
